export default "__VITE_ASSET__BixS6_Vg__"